// Pricing helpers for the tiered day-1..7 + long-stay model.
export const fmtEur = (n) => {
  if (n == null || isNaN(n)) return "";
  const v = Math.round(n * 100) / 100;
  return Number.isInteger(v) ? String(v) : v.toFixed(2);
};

// "from" price = average daily price for a 7-day rental
export const fromPerDay = (product) => {
  const t = product?.pricing?.tiers;
  if (t && t["7"] != null) return fmtEur(Number(t["7"]) / 7);
  const d = product?.pricing?.day1;
  return d != null ? fmtEur(d) : "";
};

export const priceForDays = (pricing, days) => {
  const t = pricing?.tiers;
  if (t) {
    if (days <= 7) return Number(t[String(days)]);
    return Math.round((Number(t["7"]) + (days - 7) * (Number(pricing.long_day) || 0)) * 100) / 100;
  }
  return null;
};
